import React, {useReducer} from 'react';
import { mongoObjectId } from '../utils';
import ReferrerModal from '../components/ReferrerModal';
import {DocumentPreviewModal} from '../components/DocumentPreview';

const ModalsStateContext = React.createContext();
const ModalsDispatchContext = React.createContext();

export const OPEN_CONFIGURATION = "OPEN_CONFIGURATION";
export const OPEN_PREVIEW = "OPEN_PREVIEW";
export const CLOSE_CONFIGURATION = "CLOSE_CONFIGURATION";
export const CLOSE_PREVIEW = "CLOSE_PREVIEW";
export const ADD_PARTICIPANT = "ADD_PARTICIPANT";
export const UPDATE_PARTICIPANTS = "UPDATE_PARTICIPANTS";
export const SET_TEMPLATE = "SET_TEMPLATE";
export const RESET_TEMPLATE = "RESET_TEMPLATE";
export const UNRESET = "UNRESET";
export const OPEN_GENERAL = "OPEN_GENERAL";
export const CLOSE_GENERAL = "CLOSE_GENERAL";
export const CLOSE_REFERRAL = "CLOSE_REFERRAL";
export const OPEN_REFERRAL = "OPEN_REFERRAL";

const reducer = (state, action) => {
  switch(action.type) {
    case OPEN_PREVIEW:
      console.log({action})
      return {
        ...state,
        preview: true,
        template: action.template,
        templateId: action.template.templateId,
        participants: action.participants || action.template.participants,
        center: action.center ?? false,
      }
    case OPEN_CONFIGURATION:
      return {
        ...state,
        configuration: true,
        template: action.template,
        templateId: action.template.templateId,
        participants: action.template.participants,
        center: false
      }
    case CLOSE_PREVIEW:
      return {
        ...state,
        preview: false,
      }
    case CLOSE_CONFIGURATION:
      return {
        ...state,
        configuration: false,
        // template: {},
        // initialTemplate: {},
      }
    case OPEN_GENERAL:
      return {
        ...state,
        general: true,
      }
    case OPEN_REFERRAL:
      return {
        ...state,
        referral: true,
      }
    case CLOSE_REFERRAL:
      return {
        ...state,
        referral: false,
      }
    case CLOSE_GENERAL:
      return {
        ...state,
        general: false,
        // template: {},
        // initialTemplate: {},
      }
    case SET_TEMPLATE:
       const templateId = action?.template?._id ?? action?.template?.templateId;
       delete action?.template?._id;
      return {
        ...state,
        template: { 
          ...action.template,
          templateId
        },
        templateId, 
      }
    case RESET_TEMPLATE: 
      return {
        ...state,
        template: action.template,
        reset: true,
        preview: action.resetModals ? false : state.preview,
        configuration: action.resetModals ? false : state.configuration,
      }
    case UNRESET: 
      return {
        ...state,
        reset: false
      }
    case UPDATE_PARTICIPANTS: 
      return {
        ...state,
        participants: action.participants,
      }
    case ADD_PARTICIPANT:
      return {
        ...state,
        template: {
          ...state.template,
          participants: [
            ...state.template.participants,
            {
              _id: mongoObjectId(),
              ...action.participant
            }
           
          ]
        }
      }
    default:
      return state
  }
}

const initialState = {
  configuration: false,
  general: false,
  preview: false,
  template: {},
  reset: false,
  center: false,
}

function ModalsProvider({children}) {
  const [state, dispatch] = useReducer(reducer, initialState);
  // console.log({state})
  const closeReferral = () => {
    dispatch({ type: CLOSE_REFERRAL })
  }
  const handleClosePreview = () => {
    dispatch({ type: CLOSE_PREVIEW })
  }

  return (
    <ModalsStateContext.Provider value={state}>
      <ModalsDispatchContext.Provider value={dispatch}>
        {children}
        <ReferrerModal isOpen={state.referral} onClose={closeReferral}/>
        <DocumentPreviewModal isOpen={state.preview} onClose={handleClosePreview} />
        
      </ModalsDispatchContext.Provider>
    </ModalsStateContext.Provider>
  )
}

function useModalsState() {
  const context = React.useContext(ModalsStateContext)
  if (context === undefined) {
    throw new Error('useModalsState must be used within a ModalsProvider')
  }
  return context
}

function useModalsDispatch() {
  const context = React.useContext(ModalsDispatchContext)
  if (context === undefined) {
    throw new Error('useModalsDispatch must be used within a ModalsProvider')
  }
  return context
}

function useModals() {
  return [useModalsState(), useModalsDispatch()]
}

export { ModalsProvider, useModals, useModalsState, useModalsDispatch }